import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, Link } from 'react-router-dom';
import {
  Breadcrumb,
  BackdropCircular,
  ImageGalleryDialog
} from 'components';
import {
  Card,
  Tabs,
  Tab,
  Box,
  IconButton,
  Button,
  Icon,
  Dialog,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import { TabPanel, TabContext, TabList } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import {
  getHomepageBannerGroupApi,
  addNewBannerSlideApi,
  getAssetManagerCategoryTagsApi,
  getHomepageAdditionalBannersConfigsApi
} from 'api';
import { assetManagerUrl } from 'configs';
import BannerSlidesList from './bannerSlidesList';
import UploadBannerSlide from './uploadBannerSlide';


const useStyles = makeStyles(() => ({
  modalTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row'
  },
  cancelButton: {
    padding: '12px 20px'
  },
  mainTab: {
    backgroundColor: 'rgb(15, 53, 139)',
    borderRadius: '10px',
    color: 'rgb(255, 255, 255)'
  }
}));

const AdditionalHomepageBanners = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    homepageBannerGroup,
    loadingHomepageBannerGroups,
    homepageSlidesActive,
    homepageSlidesDraft,
    loadingSaveSlide,
    loadingDeleteSlide,
    loadingAddNewSlide,
  } = useSelector((state) => state.banner_manager);

  const {
    homepageAdditionalBannersConfigs = [],
    loadingHomepageAdditionalBannersConfigs,
    savingHomepageAdditionalBannersConfigs
  } = useSelector((state) => state.store_configs);

  const {profile: {stores = []}, loadingProfile} = useSelector((state) => state.user);
  const {
    assetCategoryTags,
    loadingAssetCategoryTags
  } = useSelector((state) => state.asset_manager);

  const loading =
    savingHomepageAdditionalBannersConfigs ||
    loadingHomepageAdditionalBannersConfigs ||
    loadingHomepageBannerGroups ||
    loadingProfile ||
    loadingSaveSlide ||
    loadingDeleteSlide ||
    loadingAddNewSlide ||
    loadingAssetCategoryTags;
  const storeCode = stores.length && stores[0]?.storeCode;

  const tagId = assetCategoryTags.find((tag) => tag.label === 'Premium Plus Banner Slides')?.id;

  const [tabValue, setTabValue] = useState(location.hash);
  const [openUploadSlideDialog, setOpenUploadSlideDialog] = useState(false);
  const [openImageGallery, setOpenImageGallery] = useState(false);

  useEffect(() => {
    if (!homepageBannerGroup.length && storeCode) {
      getHomepageBannerGroupApi({dispatch, identifier: 'premium_plus_first_banner'});
    }
  }, [storeCode]);

  useEffect(() => {
    getAssetManagerCategoryTagsApi({dispatch, categoryName: 'Premium Plus Banner'});

    if (!homepageAdditionalBannersConfigs.length) {
      getHomepageAdditionalBannersConfigsApi({dispatch});
    }
  }, []);

  const [additionalBannerGroup, setAdditionalBannerGroup] = useState('premium_plus_first_banner');

  const handleChangeAdditionalBannerGroup = (event, selectAdditionalBannerGroup) => {
    if (!homepageBannerGroup.length && storeCode) {
      getHomepageBannerGroupApi({dispatch, identifier: selectAdditionalBannerGroup});
    }

    setAdditionalBannerGroup(selectAdditionalBannerGroup);
  };

  const handleChangeBannerGroupTab = (event, newValue) => {
    setTabValue(newValue);

    if (!homepageBannerGroup.length && storeCode) {
      getHomepageBannerGroupApi({dispatch, identifier: additionalBannerGroup});
    }
  };

  const addNewBanner = (slide) => {
    const slideData = {
      image: slide.filename,
      is_active: false,
      title: `${homepageBannerGroup.title} Slide ${(homepageBannerGroup.slides?.length + 1)}`,
      hosted_image: '1',
      hosted_image_thumburl: `${assetManagerUrl}/${slide.webPath}`,
      hosted_image_url: `${assetManagerUrl}/${slide.webPath}`,
      url: '',
      alt_text: `${homepageBannerGroup.title} Slide ${(homepageBannerGroup.slides?.length + 1)}`,
      slide_startdate: null,
      slide_enddate: null,
      slide_sort_order: (homepageBannerGroup.slides.length + 1),
      url_target: '_self',
      group_id: [
        `${homepageBannerGroup.group_id}`
      ]
    };

    addNewBannerSlideApi({dispatch, slideData});
  };

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Settings', path: '/settings#go_live_requirements' },
            { name: 'UI Configurations', path: '/settings#UI_configurations' },
            { name: 'Homepage Settings', path: '/configurations/homepage'},
            { name: 'Additional Homepage Banners' }
          ]}
        />
      </div>
      <div className="flex px-8 pt-0 pb-4 justify-end">
        <Button
          type="button"
          color="primary"
          variant="outlined"
          className="mr-4"
          onClick={() => setOpenUploadSlideDialog(true)}
        >
          <Icon className="mr-2">
            upload
          </Icon>
          Upload Banner
        </Button>
        <Button
          type="button"
          color="primary"
          variant="contained"
          className="mr-4"
          onClick={() => setOpenImageGallery(true)}
        >
          Search from Library
        </Button>
      </div>
      <Card elevation={25} className="px-8 pb-8 pt-4 mx-10 mb-25">
        <TabContext value={additionalBannerGroup}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList
              onChange={handleChangeAdditionalBannerGroup}
              textColor="inherit"
              indicatorColor="primary"
              aria-label="primary tabs"
              variant="fullWidth"
              className={classes.mainTab}
            >
              <Tab label="First Additional Banner" value="premium_plus_first_banner" />
              <Tab label="Second Additional Banner" value="premium_plus_second_banner" />
              <Tab label="Third Additional Banner" value="premium_plus_third_banner" />
            </TabList>
          </Box>
          <Tabs
            value={tabValue == '' ? '#active' : tabValue}
            onChange={handleChangeBannerGroupTab}
            textColor="primary"
            indicatorColor="primary"
            aria-label="secondary tabs"
            className="my-8"
          >
            <Tab
              label={<div className="flex items-center">Active ({homepageSlidesActive.length})</div>}
              value="#active"
              component={Link}
              className="capitalize font-bold flex items-center px-4"
              to="/additional-homepage-banners#active"
            />
            <Tab
              label={<div className="flex items-center">Draft ({homepageSlidesDraft.length})</div>}
              value="#draft"
              component={Link}
              className="capitalize font-bold flex items-center px-4"
              to="/additional-homepage-banners#draft"
            />
          </Tabs>
          <TabPanel value="premium_plus_first_banner">
            {(tabValue === '#active' || tabValue === '') && <BannerSlidesList data={homepageSlidesActive} />}
            {tabValue === '#draft' && <BannerSlidesList data={homepageSlidesDraft} />}
          </TabPanel>
          <TabPanel value="premium_plus_second_banner">
            {(tabValue === '#active' || tabValue === '') && <BannerSlidesList data={homepageSlidesActive} />}
            {tabValue === '#draft' && <BannerSlidesList data={homepageSlidesDraft} />}
          </TabPanel>
          <TabPanel value="premium_plus_third_banner">
            {(tabValue === '#active' || tabValue === '') && <BannerSlidesList data={homepageSlidesActive} />}
            {tabValue === '#draft' && <BannerSlidesList data={homepageSlidesDraft} />}
          </TabPanel>
        </TabContext>
      </Card>
      <Dialog
        open={openUploadSlideDialog}
        onClose={() => setOpenUploadSlideDialog(false)}
        aria-label="upload-banner-slide"
        fullWidth
        maxWidth="md"
      >
        <div className={classes.modalTitleContainer}>
          <DialogTitle className="text-16 font-semibold text-dark-gray">Upload Banner</DialogTitle>
          <IconButton
            className={classes.cancelButton}
            title="Cancel"
            color="primary"
            variant="contained"
            onClick={() => {
              setOpenUploadSlideDialog(false);
            }}
          >
            <Icon className="text-gray">cancel</Icon>
          </IconButton>
        </div>
        <DialogContent>
          <UploadBannerSlide isOpen={setOpenUploadSlideDialog} />
        </DialogContent>
      </Dialog>
      {tagId &&
        <ImageGalleryDialog
          title="Banner Library"
          open={openImageGallery}
          setOpen={setOpenImageGallery}
          onImageSelect={addNewBanner}
          cols={3}
          rowHeight={90}
          imageTagId={tagId}
          selectButtonTitle="Select this banner"
        />
      }
      <BackdropCircular loading={loading} />
    </div>
  );
};

export default AdditionalHomepageBanners;
